<template>
  <v-container fluid grid-list-md style="padding: 30px;">
    <v-row>
      <v-col cols="12" sm="12" md="6">
        <v-select outlined dense v-model="eventoId" :items="eventos" item-text="nome" item-value="id" label="Selecione o evento que deseja realizar o check-out" color="#0D47A1" @input="carregaCheckouts"></v-select>
      </v-col>
      <v-col cols="12" sm="12" md="6" style="text-align: right">
        <v-btn color="#7B1FA2" @click="realizarCheckin" dark>
          <v-icon left>check</v-icon>Realizar Check-out
        </v-btn>
      </v-col>
    </v-row>
    <br>
    <v-data-table :search="search" :headers="headers" :items="checkins" sort-by="nome" class="elevation-1" style="border-radius: 10px;">
      <template v-slot:top>
        <v-toolbar flat color="white" style="border-radius: 10px;">
          <v-toolbar-title class="textoUser">CHECK-OUTS REALIZADOS</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="search" label="Pesquisa" single-line hide-details></v-text-field>
        </v-toolbar>
      </template>
      <template slot="no-data">
        <v-row>
          <v-col>
            <v-alert dark dense text outlined :value="true" color="warning" icon="info">Nenhum check-out realizado para este evento</v-alert>
          </v-col>
        </v-row>
      </template>
      <template slot="no-results">
        <v-row>
          <v-col>
            <v-alert dark dense text outlined :value="true" color="warning" icon="info">Sua pesquisa por "{{search}}" não trouxe resultados</v-alert>
          </v-col>
        </v-row>
      </template>
    </v-data-table>

    <!-- DIÁLOGO PARA REALIZAR CHECK-OUT -->
    <v-dialog v-model="dialogoCheckin" persistent max-width="350px">
      <v-card style="border-radius: 10px;">
        <v-card-title style="justify-content: center; padding: 8px;">
          <span class="texto" style="margin-bottom: -23px">REALIZAR CHECK-OUT</span>
        </v-card-title>
        <v-card-text v-if="!validacao" style="text-align: center;padding: 0px 5px 0px">
          <v-container>
            <v-row align="center" justify="center">
              <v-col cols="12" sm="6" md="12" v-if="dialogoCheckin">
                <qrcode-stream @decode="onDecode"></qrcode-stream>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-text v-if="validacao" style="text-align: center;padding: 0px 5px 0px;">
          <v-container>
            <br>
            <v-row align="center" justify="center">
              <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                <p class="texto" :style="`color:${corValidacao}`">{{msgValidacao}}</p>
              </v-col>
              <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                <v-icon large :color="corValidacao">{{iconValidacao}}</v-icon>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions v-if="!validacao" style="margin-top: -32px;padding: 20px 5px 0px;">
          <v-container fluid grid-list-md>
            <v-layout row wrap justify-center>
              <v-flex xs6 sm6 lg6>
                <v-btn dark depressed block color="#D32F2F" style="border-radius: 7px;" large @click="dialogoCheckin = false">Fechar</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-actions>
        <v-card-actions v-if="validacao" style="margin-top: -32px;padding: 20px 5px 0px;">
          <v-container fluid grid-list-md>
            <v-layout row wrap justify-center>
              <v-flex xs12 sm12 lg12>
                <v-btn dark depressed block color="#4A148C" style="border-radius: 7px;" large @click="dialogoCheckin = false">Continuar</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- FIM DO DIÁLOGO PARA REALIZAR CHECK-OUT -->

    <!-- DIÁLOGO PARA DIGITAR A SENHA DO VIGILANTE -->
    <v-dialog v-model="confirmacaoCheckout" persistent max-width="380px">
      <v-card style="border-radius: 10px;">
        <v-card-title style="justify-content: center; padding: 8px;">
          <span class="texto">REALIZAR CHECK-OUT</span>
        </v-card-title>
        <v-card-text style="text-align: center;padding: 0px 0px 0px;">
          <v-container>
            <v-row align="center" justify="center">
              <v-flex xs10 sm10 md10 lg10>
                <img style="border-radius: 80px" :src="fotoVigilante" width="150px">
              </v-flex>
              <v-flex xs10 sm10 md10 lg10>
                <p style="font-size: 25px"><b>{{ nomeVigilante.toUpperCase() }}</b></p>
                <p style="font-size: 22px">{{ qualificacaoVigilante }}</p>
              </v-flex>
              <br>
              <v-flex xs8 sm10 md10 lg7>
                <v-checkbox
                  v-model="confirmaPagamento"
                  label="Ao informar a senha, declaro que recebi meu pagamento">
                </v-checkbox>
              </v-flex>
              <v-flex xs8 sm10 md10 lg7>
                <v-text-field
                  v-model="senhaInformada"
                  label="Solicite a senha"
                  dense
                  outlined
                  type="tel"
                  :rules="[rules.max, rules.min]"
                ></v-text-field>
              </v-flex>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions style="margin-top: -40px;padding: 20px 5px 0px;">
          <v-container fluid grid-list-md>
            <v-layout row wrap justify-center>
              <v-flex xs6 sm6 lg6>
                <v-btn dark depressed block color="#4A148C" style="border-radius: 7px;" @click="confirmarCheckout">Confirmar</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- FIM DO DIÁLOGO PARA DIGITAR A SENHA DO VIGILANTE -->
    <loading :active.sync="isLoading" :can-cancel="true" color="#7B1FA2" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
  </v-container>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import moment from 'moment'
  import axios from 'axios'
  import { mapState } from 'vuex'
  export default {
    components: { Snackbar, Loading, },
    data: () => ({
      confirmaPagamento: false,
      search: '',
      eventoId: '',
      eventoIdAtual: '',
      fullPage: true,
      isLoading: false,
      loading: false,
      dialogoCheckin: false,
      audio: '',
      tipo: '1',
      validacao: false,
      msgValidacao: '',
      iconValidacao: '',
      corValidacao: '',
      codigoQrCode: '',
      confirmacaoCheckout: false,
      senhaInformada: '',
      exibeSenha: false,
      idQrCode: '',
      idAssociacao: '',
      nomeVigilante: '',
      qualificacaoVigilante: '',
      fotoVigilante: '',
      senhaQrCode: '',
      eventos: [],
      checkins: [],
      headers: [
        { text: 'Nome', align: 'start', value: 'nome' },
        { text: 'CPF', value: 'cpf' },
        { text: 'Sexo', value: 'sexo' },
        { text: 'Telefone', value: 'telefone' },
        { text: 'Qualificação', value: 'qualificacao' },
        { text: 'Check-in', value: 'checkin' },
        { text: 'Check-out', value: 'checkout' },
      ],
      rules: {
        max: v => v.length <= 4 || 'Máximo de 4 dígitos',
        min: v => v.length >= 4 || 'Mínimo de 4 dígitos'
      },
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
    }),

    mounted() {
      this.carregaEventos()
      this.audio = new Audio(require("../assets/beep.mp3"))
    },

    methods: {
      async carregaEventos() {
        this.isLoading = true
        await axios.get(`${baseApiUrl}Eventos?filter={"where":{"empresaId":"${this.companyobj.id}"}, "order":"inicio DESC"}`).then(res => {
          if (res.data != '') {
            for (var key in res.data) {
              if (res.data.hasOwnProperty(key)) {
                this.eventos.push(res.data[key])
              }
            }
            this.eventos = this.eventos.sort(this.compare)
            this.eventoId = this.eventos[0].id
            if (this.eventoIdAtual != '')
              this.eventoId = this.eventoIdAtual
            this.isLoading = false
          } else
            this.isLoading = false
        })
        await this.carregaCheckouts()
      },

      async carregaCheckouts() {
        this.isLoading = true
        try {
          await axios.post(`${baseApiUrl}AssociacoesEvento/listaCheckout`, {"eventoId":this.eventoId}).then(response => {
            if (response.data) {
              this.checkins = response.data
              this.isLoading = false
            } else {
              this.checkins = []
            }
          })
        } catch (error) {
          this.isLoading = false
        }
      },

      realizarCheckin() {
        this.audio.play()
        this.dialogoCheckin = true
      },

      onDecode(decodedString) {
        this.codigoQrCode = decodedString
        this.audio.play()
        this.verificaQrCode()
      },

      async verificaQrCode() {
        var vm = this;
        if (this.codigoQrCode != '') {
          this.isLoading = true
          try {
            await axios.post(`${baseApiUrl}QRCodes/checkout`, {"qrcode":this.codigoQrCode, "eventoId":this.eventoId}).then(response => {
              if (response.data) {
                this.idAssociacao = response.data.associacaoEventoId
                var primeiroUltimoNome = response.data.nome.trim().split(" ")
                this.nomeVigilante = primeiroUltimoNome[0] + " " + primeiroUltimoNome[primeiroUltimoNome.length - 1]
                this.qualificacaoVigilante = response.data.qualificacao
                this.fotoVigilante = response.data.arquivoFotoPessoal
                this.senhaQrCode = response.data.senha
                this.dialogoCheckin = false
                this.confirmacaoCheckout = true
                this.isLoading = false
              }
            })
          } catch (error) {
            this.isLoading = false
            this.dialogoCheckin = false
            vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao realizar check-out. " + error.response.data.error.message, "DESCULPE")
          }
        }
      },

      async confirmarCheckout() {
        var vm = this;
        if (this.senhaInformada != this.senhaQrCode) {
          vm.$refs.chamaSnackbar.snack("#D1A102", "Senha inválida", "ATENÇÃO")
        } else if (!this.confirmaPagamento) {
          vm.$refs.chamaSnackbar.snack("#D1A102", "Informe que recebeu o pagamento!", "ATENÇÃO")
        } else {
          this.isLoading = true
          try {
            await axios.patch(`${baseApiUrl}AssociacoesEvento/${this.idAssociacao}`, {"checkout": moment().toISOString()}).then(response => {
              if (response.data) {
                this.isLoading = false
                this.confirmacaoCheckout = false
                this.carregaCheckouts()
                vm = this;
                vm.$refs.chamaSnackbar.snack("#0288D1", "Check-out realizado com sucesso!", "INFORMAÇÃO")
              }
            })
          } catch (error) {
            this.isLoading = false
            vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao salvar a senha. Tente novamente", "DESCULPE")
          }
        }
      },

      compare(a) {
        // Use toUpperCase() to ignore character casing
        const dataA = moment(this.formatDateHora(a.fim), 'DD/MM/YYYY HH:mm:ss', true).format()
        //const dataB = new Date(moment(this.formatDatePadrao(b.fim)).format('YYYY-MM-DDTHH:mm:ss.000Z').replace('-03:00', 'Z'))
        const dataC = moment().format()

        let comparison = 0;
        if (dataC >= dataA)
          comparison = 1;
        /* else
          if (dataA >= dataC && dataB < dataA)
            comparison = -1; */
        else
        if (dataC < dataA)
          comparison = -1;
        return comparison;
      },

      formatDateHora(date) {
        if (!date) return null

        const [year, month, day] = date.substr(0, 10).split('-')
        return `${day}/${month}/${year}` + " " + date.substr(11, 8)
      },
    },
  }
</script>

<style>
  .textoUser {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px;
    width: 120px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
  }
</style>